<template>
  <v-select
    :disabled="disabled"
    v-model="livingExpensesPayer"
    :items="items"
    :label="label"
    item-text="text"
    item-value="id"
    :rules="rules"
    validate-on-blur
    @change="onChange"
    chips
    :hint="hint"
    :persistent-hint="persistentHint"
  />
</template>

<script>
import { Consts } from '@/helpers/consts'
import CommonFieldTooltip from '@/components/tooltip/common-field-tooltip'

import { LivingExpensesPayerList } from '@/mixins/living-expenses-payer-list'

export default {
  components: {
    CommonFieldTooltip
  },
  mixins: [LivingExpensesPayerList],
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    hint: {
      type: String,
      required: false
    },
    persistentHint: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    livingExpensesPayer: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    items: function() {
      return this.livingExpensesPayerList.filter(x => x.id !== Consts.LIVING_EXPENSES_PAYER_NA)
    }
  },
  methods: {
    onChange: function() {
      this.$emit('change')
    }
  }
}
</script>
